import { Pipe, Injectable, PipeTransform } from '@angular/core';
import { extractDeepPropertyByMapKey, isFunction } from '../shared/utils';

@Pipe({
    name: 'groupBy',
    pure: false
})
@Injectable()
export class GroupByPipe implements PipeTransform {
    transform(input: any, discriminator: any = [], delimiter: string = '|'): any {
        if (!Array.isArray(input)) {
            return input;
        }

        return this.groupBy(input, discriminator, delimiter);
    }

    private groupBy(list: any[], discriminator: any, delimiter: string) {
        const objList= list.reduce((acc: any, payload: string) => {
            const key = this.extractKeyByDiscriminator(discriminator, payload, delimiter);

            acc[key] = Array.isArray(acc[key]) ? acc[key].concat([payload]) : [payload];

            return acc;
        }, {});

        var arrList = [];
        for (var key in objList) {
            if (objList.hasOwnProperty(key)) {
                arrList.push({
                    Label: key,
                    Options: objList[key]
                });
            }
        }
        return arrList;
    }

    private extractKeyByDiscriminator(discriminator: any, payload: string, delimiter: string) {
        if (isFunction(discriminator)) {
            return (<Function>discriminator)(payload);
        }

        if (Array.isArray(discriminator)) {
            return discriminator.map(k => extractDeepPropertyByMapKey(payload, k)).join(delimiter);
        }

        return extractDeepPropertyByMapKey(payload, <string>discriminator);
    }
}
